import { Outlet } from 'react-router-dom';
import { Offline, Online } from 'react-detect-offline';

// project imports
import Customization from '../Customization';
import SnackAlert from 'views/utilities/SnackAlert';
import Social from 'views/contact/social';
import { ApiUrl } from 'utils/Constants';

// ==============================|| MINIMAL LAYOUT ||============================== //

const MinimalLayout = () => {
    const polling = {
        enabled: true,
        url: `${ApiUrl}/api/online`,
        timeout: 3000,
        interval: 5000
    };

    return (
        <>
            <Outlet />
            {/*
            <Online polling={polling}>
                <Outlet />
            </Online>
            <Offline polling={polling}>
                <SnackAlert message="عـدم برقــراری ارتبـاط با ســرور!" type="error" hideDuration={999999999} />
                <Social />
            </Offline>
            */}
            {/* <Customization /> */}
        </>
    );
};

export default MinimalLayout;
